// src/catalog/launch/catalogPathwayCompatibility.js

const LEGACY_HANDMADE_ACTIVITY_PATHWAYS = Object.freeze([
  Object.freeze({
    legacyViewId: "overall-severity-random-practice",
    legacyCatalogSlug: "overall-severity-random-practice",
    canonicalSlug: "overall-severity",
    launchConfigurationId: "random-practice"
  }),
  Object.freeze({
    legacyViewId: "overall-severity-select-practice",
    legacyCatalogSlug: "overall-severity-select-practice",
    canonicalSlug: "overall-severity",
    launchConfigurationId: "select-practice"
  }),
  Object.freeze({
    legacyViewId: "overall-severity-upload",
    legacyCatalogSlug: "overall-severity-upload",
    canonicalSlug: "overall-severity",
    launchConfigurationId: "upload-sample"
  }),
  Object.freeze({
    legacyViewId: "capev-random-practice",
    legacyCatalogSlug: "capev-random-practice",
    canonicalSlug: "capev",
    launchConfigurationId: "random-practice"
  }),
  Object.freeze({
    legacyViewId: "capev-select-practice",
    legacyCatalogSlug: "capev-select-practice",
    canonicalSlug: "capev",
    launchConfigurationId: "select-practice"
  }),
  Object.freeze({
    legacyViewId: "capev-upload",
    legacyCatalogSlug: "capev-upload",
    canonicalSlug: "capev",
    launchConfigurationId: "upload-sample"
  }),
  Object.freeze({
    legacyViewId: "capevr-random-practice",
    legacyCatalogSlug: "capevr-random-practice",
    canonicalSlug: "capevr",
    launchConfigurationId: "random-practice"
  }),
  Object.freeze({
    legacyViewId: "capevr-select-practice",
    legacyCatalogSlug: "capevr-select-practice",
    canonicalSlug: "capevr",
    launchConfigurationId: "select-practice"
  }),
  Object.freeze({
    legacyViewId: "capevr-upload",
    legacyCatalogSlug: "capevr-upload",
    canonicalSlug: "capevr",
    launchConfigurationId: "upload-sample"
  }),
  Object.freeze({
    legacyViewId: "overall-severity-session",
    legacyCatalogSlug: "overall-severity-session",
    canonicalSlug: "overall-severity",
    launchConfigurationId: "moderate-session"
  }),
  Object.freeze({
    legacyViewId: "capev-session",
    legacyCatalogSlug: "capev-session",
    canonicalSlug: "capev",
    launchConfigurationId: "moderate-session"
  }),
  Object.freeze({
    legacyViewId: "capevr-session",
    legacyCatalogSlug: "capevr-session",
    canonicalSlug: "capevr",
    launchConfigurationId: "moderate-session"
  }),
  Object.freeze({
    legacyViewId: "2afc-overall-severity",
    legacyCatalogSlug: "2afc-overall-severity",
    canonicalSlug: "2afc",
    launchConfigurationId: "overall-severity"
  }),
  Object.freeze({
    legacyViewId: "2afc-roughness",
    legacyCatalogSlug: "2afc-roughness",
    canonicalSlug: "2afc",
    launchConfigurationId: "roughness"
  }),
  Object.freeze({
    legacyViewId: "2afc-breathiness",
    legacyCatalogSlug: "2afc-breathiness",
    canonicalSlug: "2afc",
    launchConfigurationId: "breathiness"
  }),
  Object.freeze({
    legacyViewId: "2afc-strain",
    legacyCatalogSlug: "2afc-strain",
    canonicalSlug: "2afc",
    launchConfigurationId: "strain"
  }),
  Object.freeze({
    legacyViewId: "2afc-random",
    legacyCatalogSlug: "2afc-random",
    canonicalSlug: "2afc",
    launchConfigurationId: "random-attribute"
  })
]);

function withLaunchConfigurationQuery(pathname, launchConfigurationId) {
  if (!pathname || !launchConfigurationId) {
    return pathname;
  }

  const params = new URLSearchParams();
  params.set("launchConfig", launchConfigurationId);

  return `${pathname}?${params.toString()}`;
}

function findCompatibilityEntryByViewId(viewId) {
  return LEGACY_HANDMADE_ACTIVITY_PATHWAYS.find(
    (entry) => entry.legacyViewId === viewId
  );
}

function findCompatibilityEntryByCatalogSlug(slug) {
  return LEGACY_HANDMADE_ACTIVITY_PATHWAYS.find(
    (entry) => entry.legacyCatalogSlug === slug
  );
}

export function catalogPathwayCompatibilityForLegacyViewId(viewId) {
  return findCompatibilityEntryByViewId(viewId) || null;
}

export function catalogPathwayCompatibilityForLegacyCatalogSlug(slug) {
  return findCompatibilityEntryByCatalogSlug(slug) || null;
}

export function catalogSlugForLegacyViewId(viewId) {
  return findCompatibilityEntryByViewId(viewId)?.canonicalSlug || null;
}

export function isPilotCatalogPathwaySlug(slug, launchConfigurationId = null) {
  if (slug === "grbas") {
    return launchConfigurationId === "random-practice" ||
      launchConfigurationId === "select-practice";
  }
  return Boolean(findCompatibilityEntryByCatalogSlug(slug));
}

export function canonicalPathwayRouteForLegacyViewId(viewId) {
  const match = findCompatibilityEntryByViewId(viewId);

  if (!match) {
    return null;
  }

  return withLaunchConfigurationQuery(
    `/app/${match.canonicalSlug}/open`,
    match.launchConfigurationId
  );
}

export function canonicalCatalogDetailRouteForLegacySlug(slug) {
  const match = findCompatibilityEntryByCatalogSlug(slug);

  if (!match) {
    return null;
  }

  return withLaunchConfigurationQuery(
    `/app/catalog/${match.canonicalSlug}`,
    match.launchConfigurationId
  );
}

export const catalogPathwayCompatibility =
  LEGACY_HANDMADE_ACTIVITY_PATHWAYS;
